import type { TOptions } from "i18next";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import type { TranslationKey } from "~/i18n-keys.generated";

import deCommon from "./locales/de/common.json";
import enCommon from "./locales/en/common.json";
import frCommon from "./locales/fr/common.json";
import itCommon from "./locales/it/common.json";

export const SUPPORTED_LOCALES = ["de", "en", "fr", "it"] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

const i18nInstance = i18n;

i18nInstance
  .use(initReactI18next)
  .init({
    resources: {
      de: {
        translation: deCommon,
      },
      en: {
        translation: enCommon,
      },
      fr: {
        translation: frCommon,
      },
      it: {
        translation: itCommon,
      },
    },
    lng: "de",
    fallbackLng: "de",
    initImmediate: false,
    interpolation: {
      escapeValue: false,
    },
  })
  .catch(() => {});

export const t = (key: TranslationKey, options?: TOptions) =>
  i18nInstance.t(key, options);

export default i18nInstance;
